/* YRD — subtle scroll reveal, once, respectful of reduced motion. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.yrd-reveal').forEach(function (el) { el.classList.add('is-in'); });
    return;
  }
  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );
  document.querySelectorAll('.yrd-reveal').forEach(function (el) { io.observe(el); });
})();

/* YRD — dual-write footer email signups into the existing n8n -> GoHighLevel
   funnel (same webhook the main site uses), tagged source-shop. Shopify's own
   customer capture still runs; this rides alongside it. */
(function () {
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!(f instanceof HTMLFormElement)) return;
    var email = f.querySelector('input[name="contact[email]"], input[type="email"]');
    var isCustomerForm = f.querySelector('input[name="form_type"][value="customer"]') ||
      (f.getAttribute('action') || '').indexOf('/contact') === 0;
    if (!isCustomerForm || !email || !email.value || email.value.indexOf('@') < 1) return;
    try {
      fetch('https://n8n-roostertail-u60710.vm.elestio.app/webhook/yrd-waitlist', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.value.trim(), source: 'shop' }),
        keepalive: true,
        mode: 'cors'
      }).catch(function () {});
    } catch (err) { /* capture must never block checkout-side UX */ }
  }, true);
})();
